<template>
  <div class="content-right">
    <column class="column1" :title="props.title" :ele_have_scrollbar="true">
      <template #abc>
        <rowBookCards
          v-for="(item, index) in mydata.bookArr"
          :key="index"
          :info="item"
          path="/layout/list/booksDetails"
        >
          <template #rowBook>
             <div class="bac-box">
            <img
              :class="item.img_type === 2 ? 'myrotate' : ''"
              v-complete:src="item.img_url"
            />
            </div>
          </template>
        </rowBookCards>
      </template>
    </column>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import column from "@/components/column/index.vue";
import rowBookCards from "@/components/rowBookCards/index.vue";
// import { bookRecommend } from "@/api/addedServices/index.js";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { useRoute } from "vue-router";
import { dictKeyWord } from "@/utils/dict.js";
const route = useRoute();

const mydata = reactive({
  bookArr: [],
});

const props = defineProps({
  title: {
    type: String,
    default: "必备好书",
  },
});

////////////////////////////////////////////
//推荐列表
function getRecommendFn() {
  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord[props.title];
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.bookArr = res.data.list;
  });
}

getRecommendFn();

////////////////////////////////////////////

// function bookRecommendFN() {
//   bookRecommend().then((res) => {
//     mydata.bookArr = res.data.list;
//   });
// }
// bookRecommendFN();
</script>

<style scoped lang="scss">
.content-right {
  // border: 1px solid red;
  // width: 320px;
  // height:300px;
  // 标题
  :deep(.box-column) {
    margin-bottom: 16px;
    .column-title {
      > p {
        display: none;
      }
    }

    .column-content {
      display: flex;
      overflow-x: auto;

      /* 针对webkit内核浏览器 */
      ::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }

      /* 针对Firefox */
      scrollbar-width: none; /* Firefox中隐藏滚动条 */

      /* 针对IE和Edge */
      -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
    }
  }
  // 内容
  .column1 {
    :deep(.column-content.ele-have-scrollbar) {
      display: flex;
    }
    .row-book {
      // margin-bottom: 20px;
      margin-left: 16px;
      .bac-box {
        width: 104px;
        height: 104px;
        margin-bottom:5px;
        background-color: #eeeeee;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 60px;
          height: 80px;
          flex-shrink: 0;

          // margin-right: 12px;
        }
      }

      // .box-p{
      //   margin-top:5px;
      // }
    }
    .row-book:first-of-type {
      margin-left: 0px;
    }
  }
}

// :deep(.column-content.ele-have-scrollbar) {
//   height: 400px;
//   // border:1px solid red;
// }
</style>
